import { render, staticRenderFns } from "./AirEfficiency.vue?vue&type=template&id=b8f3112a&scoped=true"
import script from "./AirEfficiency.vue?vue&type=script&lang=js"
export * from "./AirEfficiency.vue?vue&type=script&lang=js"
import style0 from "./AirEfficiency.vue?vue&type=style&index=0&id=b8f3112a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f3112a",
  null
  
)

export default component.exports